'use strict';

const { captureMessage } = require('../analytics/sentry');
const lang = window.wooGlobal.language || 'en';
const $header = $('.-header');
const $toggleMagicbarBtn = $header.find('.js-toggle-magicbar');
const Typeahead = require('jquery-typeahead/dist/jquery.typeahead.min.js');

module.exports = {
  init: init
};

const toggleMagicbar = (status) => {
  $header.toggleClass('_magicbar-open_', status);
  if ($('body').hasClass('appnav-open')) {
    $('body').toggleClass('appnav-open', false);
  }
};

function init () {
  const cta = $('.js-magicbar-input').data('i18nEmptyText');
  const inst = new Typeahead($('.js-magicbar-input'), {
    input: '.js-magicbar-input',
    display: 'url',
    hint: true,
    dynamic: true,
    delay: 250,
    maxItem: false,
    maxItemPerGroup: 5,
    filter: false,
    blurOnTab: false,
    minLength: 0,
    searchOnFocus: true,
    focusOnly: true,
    cancelButton: false,
    group: {
      template: '{{group}}'
    },
    groupOrder: ['projects', 'reviews'],
    href: `/${lang}/review/{{url|raw}}`,
    template: () => {
      return `
        <span>
          <img
            class="favico"
            onload="this.style.backgroundColor='transparent';"
            src="https://www.google.com/s2/favicons?sz=32&amp;domain={{url|raw}}"
          >
          {{url}}
        </span>
      `;
    },
    emptyTemplate: `<span>${cta}</span>`,
    source: {
      reviews: {
        ajax: {
          url: `/${lang}/user/overviewsearch`,
          data: {
            search: '{{query}}'
          },
          path: 'reviews.items',
          error: (jqXHR, textStatus, errorThrown) => {
            if (textStatus === 'abort') {
              return;
            }
            captureMessage('Magicbar reviews fetch error', {
              extra: {
                textStatus: textStatus,
                errorThrown: errorThrown
              }
            });
          }
        }
      },
      projects: {
        ajax: {
          url: `/${lang}/user/overviewsearch`,
          data: {
            search: '{{query}}'
          },
          path: 'projects.items',
          error: (jqXHR, textStatus, errorThrown) => {
            captureMessage('Magicbar projects fetch error', {
              extra: {
                textStatus: textStatus,
                errorThrown: errorThrown
              }
            });
          }
        }
      }
    },
    callback: {
      onSendRequest: (node) => {
        if (!$header.hasClass('_magicbar-open_')) {
          toggleMagicbar(true);
        }
      },
      onShowLayout: (node) => {
        if (!$header.hasClass('_magicbar-open_')) {
          toggleMagicbar(true);
        }
      },
      onHideLayout: (node) => {
        if ($header.hasClass('_magicbar-open_')) {
          toggleMagicbar(false);
        }
      },
      onReady: (node) => {
        node.on('blur', (e) => {
          e.stopImmediatePropagation();
          e.preventDefault();
        });
        $toggleMagicbarBtn.on('click', (e) => {
          e.preventDefault();
          toggleMagicbar(!$header.hasClass('_magicbar-open_'));
          inst.hideLayout();
        });
        $('body').on('click', '.typeahead__empty', (event) => {
          event.preventDefault();
          generationAjaxCall(inst.query, node);
        });
      },
      onSubmit: (node, form, item, event) => {
        event.stopImmediatePropagation();
        event.preventDefault();
        generationAjaxCall(inst.query, node);
      }
    }
  });
}

function generationAjaxCall (params, context) {
  $('.typeahead__container').addClass('loading');
  const data = `url=${params}&navigate-if-exists=1&ajax=1`;
  $.ajax({
    type: 'POST',
    data: data,
    cache: false,
    url: `/${lang}/report/generate`,
    context: context,
    dataType: 'json',
    success: (data) => {
      window.location.replace(data.url);
    },
    error: (jqXHR, textStatus, errorThrown) => {
      captureMessage('Magicbar generation post error', {
        extra: {
          textStatus: textStatus,
          errorThrown: errorThrown,
          params: params
        }
      });
      $('.typeahead__container').removeClass('loading');
      return $('#generic-error-modal').modal('show');
    }
  });
}
